export default __webpack_public_path__ + "static/media/Frame0001.3a72810a.png";